import LevelIncomeComponent from "../../Component/IncomeReport/LevelIncomeComponent"

const LevelIncome = () => {
  return (
    <div className='page-body'>
      <LevelIncomeComponent />
    </div>
  )
}

export default LevelIncome